<template>
  <div class="popover-profile ">
    <div v-if="account" class="popover-body p-0">
      <div
        slot="header"
        class="d-flex flex-column align-items-center popover-header"
      >
        <div class="bar-wrapper">
          <div class="purple-bar"></div>
        </div>

        <div class="d-flex justify-content-center">
          <div @click="optionsPosition = null">
            <LinkAccountMy>
              <Avatar
                :size="80"
                :img-url="account._avatar"
                :type="accountType"
                class="profile-avatar"
              />
            </LinkAccountMy>
          </div>
        </div>
        <div class="media-body">
          <div class="account-name-style" @click="optionsPosition = null">
            <LinkAccountMy
              class="py-1 font-size-lg font-weight-bold item-name item-name-multilines"
            >
              {{ account._name }}
            </LinkAccountMy>
          </div>
          <span
            v-if="account.isOrganization"
            class="profile-id"
            @click="optionsPosition = null"
            >@{{ account.name }}</span
          >
          <span v-else class="profile-id" @click="optionsPosition = null"
            >@{{ account._id }}</span
          >
          <span class="item-subtitle mb-2 d-block">
            {{
              account.isOrganization
                ? $t('_web_organization', 'Organisation')
                : null
            }}
          </span>
          <div v-if="!account.isOrganization" class="teams-container">
            <div v-if="clanList.length > 0" class="teams-wrapper">
              <div class="profile-clans">
                <span class="element-label">{{
                  $t('_android_leaderboard_my_clans', 'My Teams')
                }}</span>
                <div class="d-flex teams-inner" @click="optionsPosition = null">
                  <ListItemAccount
                    v-for="clan in visibleClanList"
                    :key="clan.id"
                    :secondary-model="clan"
                    :noname="true"
                    class="h-mr-3 mb-3"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="accountGames && accountGames.length > 0"
              class="fav-games-wrapper"
            >
              <span class="element-label">{{
                $t('favoriteGames', 'Favorite Games')
              }}</span>
              <div class="fav-games-inner">
                <div
                  v-for="(game, index) in visibleAccountGames"
                  :key="`${game}_${index}`"
                  class="profile-d-games h-mr-4 mb-3"
                >
                  <Avatar
                    v-if="game"
                    :size="36"
                    :img-url="game.logo"
                    :title="game.name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!account.isOrganization" class="teams-container">
          <div class="profile-links" @click="optionsPosition = null">
            <LinkAccountMy>
              <div class="link-wrap">
                <div class="img-wrap">
                  <img
                    src="@/assets/images/profile-dropdown/profile.svg"
                    class="prf-icon"
                    alt="profile-dropdown"
                  />
                </div>
                <span>{{ $t('_android_my_profile', 'My Profile') }}</span>
              </div>
            </LinkAccountMy>
            <router-link :to="{ path: '/my-tournaments' }" class="font-size-sm">
              <div class="link-wrap">
                <div class="img-wrap">
                  <img
                    src="@/assets/images/profile-dropdown/myComp.svg"
                    class="prf-icon"
                    alt="profile icon"
                  />
                </div>
                <span>{{
                  $t('_android_self_competitions', 'My Competitions')
                }}</span>
              </div>
            </router-link>
            <router-link :to="{ path: '/my-matches' }" class="font-size-sm">
              <div class="link-wrap">
                <div class="img-wrap">
                  <img
                    src="@/assets/images/profile-dropdown/myMatches.svg"
                    class="prf-icon"
                    alt="profile icon"
                  />
                </div>
                <span>{{
                  $t('_web_left-sidebar_nav-my-matches-link', 'My Matches')
                }}</span>
              </div>
            </router-link>
            <router-link :to="{ name: 'billing' }">
              <div class="link-wrap">
                <div class="img-wrap">
                  <img
                    src="@/assets/images/profile-dropdown/subs.svg"
                    class="prf-icon"
                    alt="profile icon"
                  />
                </div>
                <span>{{ $t('_web_profile_popover-billing', 'Billing') }}</span>
              </div>
            </router-link>
            <!-- <router-link v-else to="/subscription">
              <div class="link-wrap">
                <div class="img-wrap">
                  <img
                    src="@/assets/images/profile-dropdown/subs.svg"
                    class="prf-icon"
                    alt="profile icon"
                  />
                </div>
                <span>{{
                  $t('_web_profile_popover-subscriptions', 'Subscriptions')
                }}</span>
              </div>
            </router-link> -->
          </div>
          <div class="profile-links">
            <a v-if="heraShopLink" :href="heraShopLink + 'customer/account/'">
              <div class="link-wrap">
                <div class="img-wrap">
                  <img
                    src="@/assets/images/profile-dropdown/shoppingIcon.svg"
                    class="prf-icon"
                    alt="profile icon"
                  />
                </div>
                <span>{{
                  $t('_web_popvover-my-shopping-account', 'My Shopping Account')
                }}</span>
              </div>
            </a>
            <a
              v-if="heraShopLink"
              :href="heraShopLink + 'sales/order/history/'"
            >
              <div class="link-wrap">
                <div class="img-wrap">
                  <img
                    src="@/assets/images/profile-dropdown/ordersIcon.svg"
                    class="prf-icon"
                    alt="profile icon"
                  />
                </div>
                <span>{{ $t('_web_popover_my-orders', 'My Orders') }}</span>
              </div>
            </a>
          </div>
        </div>
        <div v-if="account.isOrganization" class="teams-container">
          <div class="profile-links" @click="optionsPosition = null">
            <router-link
              :to="{ path: '/tournaments-management' }"
              class="font-size-sm"
            >
              <div class="link-wrap">
                <div class="img-wrap">
                  <img
                    src="@/assets/images/profile-dropdown/myComp.svg"
                    class="prf-icon"
                    alt="profile icon"
                  />
                </div>
                <span>{{
                  $t(
                    '_web_left-sidebar_nav-tournaments-management-link',
                    'Tournaments Management'
                  )
                }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <Search
        v-if="accountOrganizations && accountOrganizations.length > 3"
        v-model="searchValue"
        class="mb-3"
      />
      <div v-for="(item, i) in itemsAssociationsFiltered" :key="i">
        <router-link
          :to="{
            name: 'switch',
            params: {
              accountType: item.type,
              accountId: item.id || item.login,
            },
          }"
          class="link-uncolor text-decoration-none org-container"
        >
          <div class="d-flex align-items-center py-3">
            <Avatar
              :type="item.type"
              :size="30"
              :img-url="item.avatar"
              class="org-avatar"
            />
            <div class="org-right ml-1 org-right-pad">
              <div class="org-right-inner org-right-pad">
                <h3 class="my-0 d-block text-truncate item-name">
                  {{ item | displayName }}
                </h3>
                <span class="item-subtitle">{{
                  item.type === $options.ORGANIZATION
                    ? $t('_web_profile-organiser', 'Organiser')
                    : item.country
                }}</span>
              </div>
              <img
                src="@/assets/images/profile-dropdown/arrowRight.svg"
                alt="arrow-right"
                class="arrow-right"
              />
            </div>
          </div>
        </router-link>
      </div>
      <hr class="hr-sidebar" />
      <SidebarFooter />
      <hr class="hr-sidebar" />
      <div
        slot="footer"
        class="profile-links d-flex justify-content-between border-bottom-0"
      >
        <router-link :to="{ name: 'signout' }" class="profile-logout">
          <div class="link-wrap logout-wrap">
            <div class="img-wrap">
              <img
                src="@/assets/images/profile-dropdown/logout.svg"
                class="prf-icon"
                alt="profile icon"
              />
            </div>
            <span>{{ $t('_web_log_out', 'Log Out') }}</span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { ORGANIZATION } from '@/constants/accounts';
import Avatar from '@/components/images/Avatar';
import LinkAccountMy from '@/components/links/AccountMy';
import ListItemAccount from '@/components/common/ListItemAccount';
import SidebarFooter from '@/components/footer/SidebarFooter.vue';
import Search from '@/components/form/HeraFormSearch';

export default {
  name: 'UserProfileSidebar',
  components: {
    LinkAccountMy,
    Avatar,
    ListItemAccount,
    SidebarFooter,
    Search,
  },
  data() {
    return {
      optionsPosition: null,
      organizationListIsLoadedFor: '',
      accountOrganizations: null,
      showAll: false,
      dropdown: false,
      searchValue: '',
    };
  },

  computed: {
    ...mapGetters(['accountKey', 'isAuthorized', 'gameByID']),
    ...mapGetters([
      'my',
      'phMaxLink',
      'subscriptions',
      'userHasActiveSubscription',
    ]),
    ...mapState('my', ['account', 'accountType']),

    accountGames() {
      if (!this.account || !this.account.games) {
        return null;
      }
      console.log(this.account.games);
      return this.account && this.account.games
        ? this.account.games.map(item => this.gameByID(item))
        : [];
    },
    itemsAssociationsFiltered() {
      if (!this.accountOrganizations) {
        return null;
      }
      if (this.searchValue && this.searchValue.length > 0) {
        const query = this.searchValue.toLowerCase();
        return this.accountOrganizations
          .filter(
            account =>
              !(
                account.name === this.account.name ||
                account.login === this.account.login
              )
          )
          .filter(
            account =>
              (account.name && account.name.toLowerCase().includes(query)) ||
              (account.login && account.login.toLowerCase().includes(query))
          );
      } else {
        return this.accountOrganizations.filter(
          account =>
            !(
              account.name === this.account.name ||
              account.login === this.account.login
            )
        );
      }
    },

    billingAvailable() {
      return this.$store.getters.phMaxLink && !this.account.isOrganization;
    },
    visibleAccountGames() {
      if (!this.accountGames) {
        return null;
      }
      return this.showAll ? this.accountGames : this.accountGames.slice(0, 8);
    },
    ...mapGetters('my/clans', { myClans: 'clanList' }),
    ...mapGetters('current/clans', { clans: 'clanList' }),
    ...mapGetters('sidebars', ['profileOpen']),
    label() {
      return this.$t('_web_profile-info_team-header', `Teams`, {
        name: this.account._name,
      });
    },
    isMyAccount() {
      return this.myAccountID === this.accountId;
    },
    clanList() {
      return this.isMyAccount ? this.myClans : this.clans;
    },
    visibleClanList() {
      return this.showAll ? this.clanList : this.clanList.slice(0, 3);
    },
    isCollapsible() {
      return this.clanList.length > 3;
    },
    dummy() {
      return this.$lodash.isEmpty(this.clanList)
        ? this.$t('_web_profile-info_no-clan', 'No Clan')
        : null;
    },
    heraShopLink() {
      const region = JSON.parse(localStorage.getItem('region'));
      const locale = JSON.parse(localStorage.getItem('locale'));
      return region.feature_flags.marketplace_url
        ? `${region.feature_flags.marketplace_url}${locale.key}-sa/`
        : null;
    },
  },

  created() {
    // this.fetchUserSubscriptions();
    this.$options.ORGANIZATION = ORGANIZATION;
  },
  async mounted() {
    this.fetchMyOrganizations().then(res => {
      this.organizationListIsLoadedFor = this.accountId;
      this.accountOrganizations = this.$lodash.cloneDeep(res);
    });
    this.togglePopover();
  },

  methods: {
    ...mapActions('my', ['fetchMyOrganizations']),
    ...mapActions('sidebars', ['setProfileOpen']),
    ...mapActions(['fetchUserSubscriptions']),
    ...mapActions(['openModal']),
    popoverSwitched(isVisible) {
      if (!isVisible) {
        this.optionsPosition = null;
      }
    },
    togglePopover() {
      if (!this.isAuthorized) {
        this.openModal({
          name: 'PleaseSignIn',
          settings: {
            variant: 'fit-content',
          },
        });
        return;
      }

      if (this.organizationListIsLoadedFor !== this.accountId) {
        this.accountOrganizations = null;
        this.fetchMyOrganizations().then(res => {
          this.organizationListIsLoadedFor = this.accountId;
          this.accountOrganizations = this.$lodash.cloneDeep(res);
        });
      }
      this.optionsPosition = this.optionsPosition ? null : this.$el;
    },
  },
  //
  toggleSeeAll() {
    this.showAll = !this.showAll;
  },
};
</script>

<style lang="scss" scoped>
.popover-profile {
  position: relative;

  .profile-avi {
    border: solid 2px $hr-bg-accent;
  }

  .popover-trigger {
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
  }

  .popover-body {
    right: -17rem;
    width: 40vw;
    padding-right: 10px !important;
    top: $hr-spacing-07 !important;
    @media (max-width: 700px) {
      width: 60vw;
      padding-left: 20px !important;
    }
    @media (max-width: 470px) {
      width: 100vw;
      padding-left: 20px !important;
    }
    .list-loader {
      .list-wrapper {
        border-radius: unset !important;
      }
      ul {
        background-color: $ph-card;
      }
      li {
        border-bottom: 1px solid $ph-input-bg;
        &:last-child {
          border-bottom: none;
        }
      }
      .media {
        white-space: normal;
      }
      .media-body {
        width: 100% !important;
      }
      .item-name {
        line-height: 1.25rem;
      }
      .item-name-multilines {
        @include text-multiline-ellipses(2, 24px);
      }
    }
    .btn-action {
      height: 32px;
      line-height: 32px;

      svg {
        height: 24px;
        margin-top: -4px;
      }
    }
    .popover-footer {
      display: flex;
      flex-direction: column;
    }
    .item-subtitle {
      font-size: 0.75rem;
      font-weight: 500;
      color: $ph-secondary-text;
      line-height: 1.2rem;
    }
  }
  .float-dropbox {
    .list-loader {
      min-height: unset !important;
      max-height: 50vh;
    }
    &:not(.loading-accounts) .list-loader {
      min-height: unset !important;
    }
    &.no-accounts .list-loader {
      display: none !important;
    }
  }
  .list-unstyled {
    padding: 0;
  }
}

.org-container {
  border-bottom: 1px solid $hr-clr-border1;
  :hover {
    background-color: $hr-bg-hover-notif;
  }
  div {
    padding-inline: 14px !important;
    .org-right-pad {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }

  &:hover {
    background-color: $hr-bg-hover-notif !important;
  }
}

.org-right {
  padding-left: 0px !important;
  margin-top: auto;
  margin-bottom: auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.org-right-inner {
  padding-inline: unset;
  padding-left: 0px !important;
  display: flex;
  flex-direction: column;
}

.media {
  padding-top: $hr-spacing-07;
}

.media-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: $hr-spacing-05;
  padding-right: $hr-spacing-05;
  padding-bottom: $hr-spacing-05;
  border-bottom: 1px solid $hr-clr-border1;
  width: 100%;
}

.profile-avatar {
  mask-image: none;
  border-radius: 10px;
  border: solid 3px $hr-bg-accent;
  margin-top: $hr-spacing-07;
}

.profile-id {
  color: $hr-text-quaternary;
}

.fav-games-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: $hr-spacing-05;
}

.teams-inner {
  overflow-x: hidden;
}

.fav-games-inner {
  display: flex;
  overflow-x: hidden;
  width: 100%;
  justify-content: center;
}

.teams-container {
  width: 100%;
}

.teams-wrapper {
  width: 100%;
}

.profile-clans {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: $hr-spacing-05;
}

.element-label {
  font-size: $hr-text-small;
  padding-bottom: $hr-spacing-03;
}

.profile-d-games {
  padding-top: $hr-spacing-03;
}

.profile-bottom {
  width: 100%;
  height: $hr-spacing-10;
}

.profile-links {
  border-bottom: 1px solid $hr-clr-border1;
  font-size: $hr-text-small;

  .prf-icon {
    padding: $hr-spacing-03;
    padding-left: 0;
    padding-right: 0.8rem;

    .app-rtl & {
      transform: scaleX(-1);
    }
  }

  a {
    font-weight: 500;

    &:hover {
      color: white;
    }
  }
}

.profile-logout {
  width: 100%;
  padding-bottom: 1.95rem;
}

.arrow-right {
  .app-rtl & {
    rotate: 180deg;
  }
}

.link-wrap {
  display: flex;
  align-items: center;
  padding: $hr-spacing-03 $hr-spacing-05 $hr-spacing-03 $hr-spacing-05;

  &:hover {
    background-color: $hr-bg-hover-notif;
  }
}

.logout-wrap {
  &:hover {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}

.img-wrap {
  width: 35px;
}

.org-avatar {
  @include auto-rtl(margin-right, $hr-spacing-03);
}

.bar-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
}

.purple-bar {
  width: 18px;
  height: 4px;
  background-color: $hr-bg-accent;
  position: fixed;
  margin-top: 2px;
  @include auto-rtl(margin-right, 25px);
}

@media screen and (max-height: 834px) {
  .teams-wrapper {
    display: none;
  }

  .fav-games-wrapper {
    display: none;
  }
}
.hr-sidebar {
  margin: 0;
}
.purple-bar {
  display: none;
}
.profile-clans {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 850px) {
  .nofix-style {
    display: none !important;
  }
}
</style>
